<template>
	<section id="oxxopay">
		<div class="opps">
			<div class="opps-header">
				<div class="opps-reminder">Ficha digital. No es necesario imprimir.</div>
				<div class="opps-info">
					<div class="opps-brand"><img loading="lazy" src="images/oxxopay_brand.png" alt="OXXOPay"></div>
					<div class="opps-ammount">
						<h3>Monto a pagar</h3>
						<h2>$ {{ $route.params.total | pesos }}<sup>MXN</sup></h2>
						<p>OXXO cobrará una comisión adicional al momento de realizar el pago.</p>
					</div>
				</div>
				<div class="opps-reference">
					<img loading="lazy" :src="$route.params.barcode" :alt="$route.params.reference" width="100%">
				</div>
				<div class="opps-reference">
					<h3>Referencia</h3>
					<h1>{{ $route.params.reference }}</h1>
				</div>
			</div>
			<div class="opps-instructions">
				<h3>Instrucciones</h3>
				<ol>
					<li>Acude a la tienda OXXO más cercana. <a href="https://www.google.com.mx/maps/search/oxxo/" target="_blank">Encuéntrala aquí</a>.</li>
					<li>Indica en caja que quieres realizar un pago de <strong>OXXOPay</strong>.</li>
					<li>Dicta al cajero el número de referencia en esta ficha para que tecleé directamete en la pantalla de venta.</li>
					<li>Realiza el pago correspondiente con dinero en efectivo.</li>
					<li>Al confirmar tu pago, el cajero te entregará un comprobante impreso. <strong>En el podrás verificar que se haya realizado correctamente.</strong> Conserva este comprobante de pago.</li>
				</ol>
				<div class="opps-footnote">Al completar estos pasos recibirás un correo de <strong>MMKGroup</strong> confirmando tu pago.</div>
			</div>
		</div>	
	</section>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'thanksoxxo',
	components: {
	},
	mounted(){
		this.$store.commit('finishStore');
	},
	filters: {
		pesos: function(number){
			return new Intl.NumberFormat("es-MX").format(number);
		}
	},
}
</script>
